import { getTenantStore } from "../../stores/tenantStore";

type TenantLogoProps = {
	tenantKey: string;
	// The logo's width and height, in pixels.
	size?: number;
	// Also shows the tenant's name, after the logo if it has one.
	showName?: boolean;
};

export function TenantLogo({
	tenantKey,
	size = 50,
	showName = false,
}: Readonly<TenantLogoProps>) {
	const tenantStore = getTenantStore();
	const tenantList = tenantStore.getTenantList();

	const tenant = tenantList.find((tenant: any) => tenant.value === tenantKey);

	if (showName) {
		const name = tenant?.name || tenant?.displayName || tenantKey; // NOSONAR: an empty stored name falls through too
		return (
			<span className="inline-flex items-center gap-2 min-w-0">
				{tenant?.logo && (
					<img
						src={tenant.logo}
						alt=""
						style={{ width: size, height: size, objectFit: "contain" }}
					/>
				)}
				<span>{name}</span>
			</span>
		);
	}

	return (
		<>
			{tenant?.logo ? (
				<img
					src={tenant?.logo}
					alt="Tenant Logo"
					style={{
						width: size,
						height: size,
						marginRight: 4,
					}}
				/>
			) : (
				<span style={{ marginTop: 4, display: "block" }}>{tenantKey}</span>
			)}
		</>
	);
}
